import Image from 'next/image';
import Link from 'next/link';
import { HTMLAttributes } from 'react';

interface ISingleCarouselCardProps extends HTMLAttributes<HTMLDivElement> {
  info: {
    banner: string;
    title: string;
    body: string;
    buttonText: string;
    url: string;
    countItems: number;
  };
  sizes: string;
}

export default function HomeVillasCarouselItem({
  info,
  sizes,
}: ISingleCarouselCardProps) {
  return (
    <Link
      href={info.url}
      className="min-h-[60vh] desktop:min-h-[440px] max-h-[60vh] desktop:max-h-[850px] desktop:h-full m-0 relative transition-all group block">
      <Image
        src={
          info.banner !== ''
            ? `https://villatravellers-${
                process.env.NEXT_PUBLIC_S3_ENV || 'test'
              }.s3.amazonaws.com/thumbs/1920w_webp/${info.banner}`
            : 'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/placeholder.jpg'
        }
        alt="villas"
        loading="lazy"
        fill
        quality={85}
        sizes={sizes}
        className="object-cover shadow-lg group-hover:shadow-2xl transition-shadow"
      />
      <div className="absolute bottom-0 left-0 min-h-1/3 pt-20 px-6 pb-6 flex flex-col gap-2 justify-center items-start w-full bg-gradient-to-t from-black text-white">
        <div className="grid gap-3">
          <div className="grid gap-1">
            <strong className="text-xl">{info.title}</strong>
            <div className="opacity-80">{info.countItems} villas</div>
          </div>
          <div className="transition-all duration-300 ease-in-out overflow-hidden h-0 group-hover:h-6 uppercase opacity-100 group-hover:opacity-100 relative">
            <div className="flex items-center gap-2">
              <span className="w-6 h-[2px] bg-[#ebbf20] text-sm" />
              <span className="tracking-widest text-sm">View all villas</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
